<template>
  <div
    id="screensaver"
    ref="screensaver"
    :style="{ opacity: screensaverOpacity }"
  >
    <img
      class="logo"
      src="/logo/250223_FD_FietesFete_Logo_weiss_JM.svg"
      ref="logo"
      :style="{
        top: `${logoY}px`,
        left: `${logoX}px`,
        fill: logoColor,
        transition: `top ${verticalDuration}ms ease-in-out , left ${horizontalDuration}ms ease-in-out`,
      }"
    />
  </div>
</template>
<script>
export default {
  props: ["screensaverOpacity"],
  mounted() {
    window.addEventListener("resize", this.onResize);
    setTimeout(() => {
      this.onResize();
    }, 100);
  },
  data() {
    return {
      width: 0,
      height: 0,
      logoWidth: 0,
      logoHeight: 0,
      logoX: 0,
      logoY: 0,
      logoColor: null,
      horizontalMovement: true,
      verticalMovement: true,
      verticalDuration: 0,
      horizontalDuration: 0,
      verticalLength: 0,
      horizontalLength: 0,
      speed: 0.1, // In pixels per second
    };
  },
  methods: {
    bumpEdge() {
      this.logoColor =
        "hsl(" + Math.floor(Math.random() * 360) + ", 100%, 50%)";
    },
    moveDown() {
      let duration = (this.verticalLength - this.logoY) / this.speed;
      this.verticalDuration = duration;
      this.logoY = this.height - this.logoHeight;
      setTimeout(() => {
        this.bumpEdge();
        this.moveUp();
      }, duration);
    },
    moveLeft() {
      let duration = this.logoX / this.speed;
      this.horizontalDuration = duration;
      this.logoX = 0;
      setTimeout(() => {
        this.bumpEdge();
        this.moveRight();
      }, duration);
    },
    moveRight() {
      let duration = (this.horizontalLength - this.logoX) / this.speed;
      this.horizontalDuration = duration;
      this.logoX = this.width - this.logoWidth;
      setTimeout(() => {
        this.bumpEdge();
        this.moveLeft();
      }, duration);
    },
    moveUp() {
      let duration = this.logoY / this.speed;
      this.verticalDuration = duration;
      this.logoY = 0;
      setTimeout(() => {
        this.bumpEdge();
        this.moveDown();
      }, duration);
    },
    onResize() {
      this.width = this.$refs.screensaver.offsetWidth;
      this.height = this.$refs.screensaver.offsetHeight;
      this.logoWidth = this.$refs.logo.offsetWidth;
      this.logoHeight = this.$refs.logo.offsetHeight;

      this.logoX = Math.random() * (this.width - this.logoWidth);
      this.logoY = Math.random() * (this.height - this.logoHeight);

      setTimeout(() => {
        this.verticalLength = this.height - this.logoHeight;
        this.horizontalLength = this.width - this.logoWidth;
        if (this.horizontalMovement) {
          Math.random() >= 0.5 ? this.moveRight() : this.moveLeft();
        }
        if (this.verticalMovement) {
          Math.random() >= 0.5 ? this.moveDown() : this.moveUp();
        }
      }, 100);
    },
  },
};
</script>
<style scoped lang="scss">
$colorMain: #1976d2;
$colorAccent: #fdd835;
$mobileSize: 1000px;

div#screensaver {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1s linear;
}

img.logo {
  position: absolute;
  width: 50vw;
  height: auto;
}
</style>
